<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-lowstock-table">
            <div class="dw-lowstock-thead">
                <span class="dw-lowstock-th dw-lowstock-th--name">{{ $t('common.dashboard.widgetLabels.lowStockProduct') }}</span>
                <span class="dw-lowstock-th dw-lowstock-th--stock">{{ $t('common.dashboard.widgetLabels.lowStockStock') }}</span>
                <span class="dw-lowstock-th dw-lowstock-th--status">{{ $t('common.dashboard.widgetLabels.lowStockStatus') }}</span>
            </div>
            <div v-if="items.length" class="dw-lowstock-tbody">
                <div class="dw-lowstock-tr" v-for="item in items" :key="item.id" :class="{ 'dw-lowstock-tr--critical': isCritical(item) }">
                    <span class="dw-lowstock-td dw-lowstock-td--name">{{ item.name }}</span>
                    <span class="dw-lowstock-td dw-lowstock-td--stock">{{ qty(item.total_quantity) }} / {{ qty(item.min_quantity) }}</span>
                    <span class="dw-lowstock-td dw-lowstock-td--status">
                        <span v-if="isCritical(item)" class="dw-lowstock-chip dw-lowstock-chip--danger"><i class="bi bi-exclamation-circle-fill"></i> {{ $t('common.dashboard.widgetLabels.lowStockCritical') }}</span>
                        <span v-else class="dw-lowstock-chip dw-lowstock-chip--warn"><i class="bi bi-arrow-down"></i> {{ $t('common.dashboard.widgetLabels.lowStockLow') }}</span>
                    </span>
                </div>
            </div>
            <div v-else class="dw-lowstock-empty">
                <i class="bi bi-check-circle"></i>
                <span>{{ $t('common.dashboard.widgetEmpty.lowStock') }}</span>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'low_stock',
    titleKey: 'common.dashboard.widgetTitles.low_stock',
    icon: 'bi-exclamation-triangle',
    accent: 'var(--bs-warning)',
    accentBg: 'rgba(var(--bs-warning-rgb, 255, 199, 0), 0.12)',
    glassRgb: '255, 199, 0',
    defaultCol: 2,
    defaultRow: 1,
    source: { type: 'statistics', key: 'low_stock_items' },
};

export default {
    name: 'LowStockWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        items() {
            return Array.isArray(this.apiData) ? this.apiData : [];
        },
    },
    methods: {
        qty(v) {
            const n = parseFloat(v) || 0;
            return Number.isInteger(n) ? n : n.toFixed(2).replace(/\.?0+$/, '');
        },
        isCritical(item) {
            const cur = parseFloat(item.total_quantity) || 0;
            const min = parseFloat(item.min_quantity) || 0;
            if (min <= 0) return cur <= 0;
            return cur < min * 0.3;
        },
    },
};
</script>

<style>
.dw-lowstock-empty {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--bs-success);
    font-size: 12px;
}
.dw-lowstock-empty .bi {
    font-size: 28px;
    opacity: 0.6;
}
</style>
